import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Category } from '@features/product/interface/product.interface';
import { ProductService } from '@features/product/service/product.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FcContactComponent } from '@shared/components/fc-contact/fc-contact.component';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'fc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  imports: [
    CommonModule,
    RouterLink,
    FontAwesomeModule,
    FcContactComponent,
    SkeletonModule,
  ],
})
export class FooterComponent {
  year = new Date().getFullYear();
  faFacebookF = faFacebookF;
  faEnvelope = faEnvelope;

  categories: Category[] = [];
  categoryLoading = false;

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.loadCategories();
  }

  loadCategories() {
    this.categoryLoading = true;
    this.productService
      .getProductCategories('?limit=1000&page=1&parent_id=')
      .subscribe({
        next: (res) => {
          this.categories = res.data.product_categories;
          this.categoryLoading = false;
        },
        error: (err) => {
          this.categoryLoading = false;
        },
      });
  }
}
